import type {
  EffectConfig,
  OneOfEntranceOngoingEffects,
  ScrollEffectConfig,
  OneOfScrollEffects,
} from '@wix/effects-kit';
import { cleanupPanelEffect } from './assets/cleanupPanelEffect';
import { compareEffects } from './assets/compareEffects';
import { Effect } from './types';

export * from './panels/MotionPanel';
export * from './types';

export { cleanupPanelEffect, compareEffects };
export const cleanupEffectsAndCompare = (
  a: {
    effect: Effect;
    config:
      | EffectConfig<OneOfEntranceOngoingEffects>
      | ScrollEffectConfig<OneOfScrollEffects>
      | null;
  },
  b: {
    effect: Effect;
    config:
      | EffectConfig<OneOfEntranceOngoingEffects>
      | ScrollEffectConfig<OneOfScrollEffects>
      | null;
  },
) => {
  const cleanedA = cleanupPanelEffect(a.effect, a.config);
  const cleanedB = cleanupPanelEffect(b.effect, b.config);
  return compareEffects(cleanedA, cleanedB);
};
